module.exports = __webpack_public_path__ + "static/img/UTSG教室_2.10aee50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG教室_2.png
// module id = BHbl
// module chunks = 0